import { useAuthContext } from "@/context/AuthContext";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuthContext();

  // Example: Allow navigation for authenticated users or to specific paths like reset-password
  if (isAuthenticated) {
    return <Outlet />;
  }

  // Prevent redirecting if user is navigating to /reset-password without being fully logged in
  const allowedPaths = ["/reset-password"];
  const currentPath = window.location.pathname;

  if (allowedPaths.some((path) => currentPath.startsWith(path))) {
    console.log("allowed path", currentPath);
    return <Outlet />;
  }
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
